<ng-container *transloco="let t; read: 'widgets.interactive-smart-summary'">
  <p>
    @for (segment of summarySegments; track segment) {
      <span>
        @if (segment.highlighted) {
          <span
            [matMenuTriggerFor]="menuTemplate"
            class="highlight"
            [matTooltip]="tooltipDisplayText"
          >
            {{ segment.text }}
          </span>
        } @else {
          <span>
            {{ segment.text }}
          </span>
        }
      </span>
    }
  </p>
</ng-container>
